import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/list", params, successCallback, failCallback, exceptionCallback);
	},listInts: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/listInts", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/team/team/save", params, successCallback, failCallback, exceptionCallback);
	},
	//添加团队和团队成员
	saveTeam: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/team/team/saveTeam", params, successCallback, failCallback, exceptionCallback);
	},
	//修改团队和团队成员
	updateTeam: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/team/team/updateTeam", params, successCallback, failCallback, exceptionCallback);
	},
	//编辑页面删除成员
	delMember: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/team/team/delMember", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},getMembers: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/team/team/getMembers", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/team/team/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/team/team/remove", params, successCallback, failCallback, exceptionCallback);
	},removeBySid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/team/team/removeBySid", params, successCallback, failCallback, exceptionCallback);
	},removeByTid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/team/team/removeByTid", params, successCallback, failCallback, exceptionCallback);
	},

}

export default api;
